import type { Common } from "@beautypie/segment";
import parser from "ua-parser-js";

import { isBrowser } from "@shared/utils.environment";

import type { DeepRequired } from "tracking";

type Device = DeepRequired<Common, ["context", "device"]>["context"]["device"];

export const parseDevice = (): Device | undefined => {
  if (isBrowser()) {
    const device = parser(navigator.userAgent);
    return {
      category: device.device.type,
      manufacturer: device.device.vendor,
      model: device.device.model,
      browser: device.browser.name,
      browserSize: `${window.screen.width}x${window.screen.height}`,
      browserVersion: device.browser.version
    };
  }

  return undefined;
};
